import { locales } from "@i18n/react";
import { z } from "zod";

export const jwtSchema = z.object({
  accountCreatedAt: z.iso.datetime().optional(),
  bannedReason: z.number().nullable().optional(),
  cityLocationId: z.number().nullable().optional(),
  cohorts: z.number().array().optional(),
  communityIds: z.number().array().optional(),
  consent: z.number().array().nullable().optional(),
  device: z.number().optional(),
  email: z.email().nullable().optional(),
  exp: z.number(),
  iat: z.number(),
  id: z.number(),
  isAnonymous: z.boolean().optional(),
  isCoppa: z.boolean().optional(),
  isHerald: z.boolean().optional(),
  isKidAccount: z.boolean().optional(),
  isSubscribed: z.boolean().optional(),
  language: z.enum(locales).nullable().optional().catch(null),
  lastName: z.string().nullable().optional(),
  name: z.string().nullable().optional(),
  permissions: z.number().array().optional(),
  phone: z.string().nullable().optional(),
  plan: z.string().nullable().optional(),
  platform: z.string().optional(),
  trial: z.boolean().nullable().optional(),
  sessionsCount: z.number().optional(),
  userCreatedAt: z.iso.datetime().optional(),
  userPolicyIds: z.number().array().optional(),
});

export type JWTPayload = z.infer<typeof jwtSchema>;
